import React from "react";
import './TermsModal.css';

const TermsModal = ({ isOpen, onClose, onAccept }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content shadow-lg rounded">
        <div className="modal-header">
          <h3 className="modal-title font-bold text-lg">Terms and Conditions</h3>  
          <p><i>Effective Date: 24/3/25</i></p>           
        </div>

        <div className="modal-body max-h-[60vh] overflow-y-auto text-left p-4 space-y-4">
   

          <h6 className="font-semibold">
            Welcome
          </h6>

          <p>
            Welcome to the YPO Carbon Calculator, a platform provided in partnership with BlocCarbon
            to help YPO members measure and offset the carbon emissions from their travel by
            contributing to certified climate projects.
          </p>

          <p>
            By accessing or using the YPO Carbon Calculator at <i>https://ypocarboncalculator.com</i>, you
            agree to be bound by these Terms and Conditions.
          </p>

          <h6 className="font-semibold">1. Purpose of the Tool</h6>
          <ul className="list-disc list-inside ml-4">
            <li>Estimate the carbon emissions associated with your air travel.</li>
            <li>Provide an option to contribute funds toward certified carbon offset projects (Gold Standard or Verra/VCS certified).</li>
            <li>Promote environmental responsibility within the YPO community.</li>
          </ul>

          <h6 className="font-semibold">2. Emissions Calculations</h6>
          <ul className="list-disc list-inside ml-4">
            <li>Based on flight data from various reputable sources</li>
            <li>Results are indicative and may vary due to different factors.</li>
            <li>Tool is for general awareness and educational purposes.</li>
          </ul>

          <h6 className="font-semibold">3. Offsetting Contributions</h6>
          <ul className="list-disc list-inside ml-4">
            <li>Users may donate to selected carbon offset projects.</li>
            <li>Projects are Gold Standard or VCS verified.</li>
            <li>Contributions are not carbon credit purchases and are non-refundable.</li>
          </ul>

          <h6 className="font-semibold">4. Project Impact and Verification</h6>
          <ul className="list-disc list-inside ml-4">
            <li>Projects reduce carbon and support communities.</li>
            <li>Details and certifications are available upon request.</li>
          </ul>

          <h6 className="font-semibold">5. No Legal or Financial Advice</h6>
          <p>This tool is not intended as legal, environmental, or financial advice.</p>

          <h6 className="font-semibold">6. Data Privacy</h6>
          <ul className="list-disc list-inside ml-4">
            <li>May collect non-personal data for analytics.</li>
            <li>No personal data is stored without consent.</li>
            <li>Refer to our Privacy Policy for full details.</li>
          </ul>

          <h6 className="font-semibold">7. Liability Disclaimer</h6>
          <ul className="list-disc list-inside ml-4">
            <li>No liability for use of the tool or reliance on estimates.</li>
            <li>No guarantees of error-free performance.</li>
          </ul>

          <h6 className="font-semibold">8. Changes to Terms</h6>
          <p>We may modify these Terms at any time. Continued use constitutes acceptance.</p>

          <h6 className="font-semibold">9. Contact</h6>
          <p>
            BlocCarbon Support<br />
            Email: sam@bloccarbon.com<br />
            Website: https://ypocarboncalculator.com
          </p>
        </div>

        <div className="modal-footer p-4">
          <label className="gap-2">
            <input type="checkbox" onChange={onAccept} /> I accept the terms and conditions.
          </label>
          <button className="btn btn-secondary" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default TermsModal;